import { Reducer } from '@reduxjs/toolkit';

const appRestUserReducer: Reducer = (state, { payload }) => {
  if (!state) {
    return { restUser: null };
  }

  if (!payload) {
    return state;
  }

  return { ...state, restUser: payload };
};

export default appRestUserReducer;
